import { orderedStatuses } from '../../constants'
export const formatStatusCode = (statusCode: number): typeof orderedStatuses[number] => {
  return orderedStatuses[statusCode]
}
